import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard4 from './Dashboard4';
import DashboardAnalysisTabLatest from './DashboardAnalysisTabLatest';

function Product3Router() {
  useEffect(() => {
    // console.log("Product2Router mounted");

    return () => {
      // console.log("Product2Router unmounted");
    };
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/product4/dashboard" replace />} />
      <Route path="/dashboard" element={<Dashboard4 />} />
      <Route path="/analysis" element={<DashboardAnalysisTabLatest />} />
      <Route path="*" element={<Navigate to="/product4/dashboard" replace />} />
    </Routes>
  );
}

export default Product3Router;
